import { render, staticRenderFns } from "./shopWithdrawRecord.vue?vue&type=template&id=0d22b0ce&scoped=true&lang=pug&"
import script from "./shopWithdrawRecord.vue?vue&type=script&lang=ts&"
export * from "./shopWithdrawRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d22b0ce",
  null
  
)

export default component.exports